const REQUEST_STATUSES = {
  idle: 'idle',
  loading: 'loading',
  error: 'error',
};

const POPUP_STEPS = {
  disconnect: 'disconnect',
  success: 'success',
  error: 'error',
};

const DEACTIVATION_STATUSES = {
  error: 0,
  inProgress: 1,
  rejected: 2,
  complete: 3,
  requestSent: 4,
};

export {
  REQUEST_STATUSES,
  POPUP_STEPS,
  DEACTIVATION_STATUSES,
};
